import { motion } from "framer-motion";
import { MessageCircle, Instagram } from "lucide-react";
import { waLink, WHATSAPP_DISPLAY, INSTAGRAM_URL } from "@/data/siteData";

export default function ContactCTA() {
  return (
    <section data-testid="contact-cta-section" className="px-5 sm:px-8 pb-20 sm:pb-28">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="max-w-5xl mx-auto relative overflow-hidden rounded-[2rem] border border-gold/25 bg-gradient-to-br from-navy-card via-navy-deep to-navy-abyss p-10 sm:p-16 text-center grain"
      >
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-96 h-96 bg-gold/10 rounded-full blur-3xl pointer-events-none" />
        <p className="text-[11px] sm:text-xs uppercase tracking-[0.32em] text-gold font-semibold">Prefer Talking Directly?</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mt-4">
          Chat With a <span className="gold-text italic">Goa Expert</span> Right Now
        </h2>
        <p className="mt-5 text-sm sm:text-base text-slate-300 max-w-xl mx-auto leading-relaxed">
          Skip the form — message us on WhatsApp for instant custom quotes, live availability and honest local advice.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={waLink("Hi RAJ TRAVELS GOA! I'm looking for a Goa holiday package. Please share details and prices.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="direct-whatsapp-banner-btn"
            className="inline-flex flex-col items-center gap-0.5 bg-[#25D366] text-white font-semibold px-8 py-3.5 rounded-2xl sm:rounded-full hover:brightness-110 hover:shadow-[0_0_36px_rgba(37,211,102,0.35)] transition-[box-shadow,transform,filter] duration-300 hover:-translate-y-0.5 w-full sm:w-auto justify-center"
          >
            <span className="inline-flex items-center gap-2">
              <MessageCircle className="w-5 h-5" />
              Chat on WhatsApp
            </span>
            <span className="text-xs font-medium opacity-90">{WHATSAPP_DISPLAY}</span>
          </a>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-cta-btn"
            className="inline-flex items-center gap-2.5 border border-gold/40 text-gold-light font-medium px-8 py-4 rounded-full hover:bg-gold/10 transition-colors duration-300 w-full sm:w-auto justify-center"
          >
            <Instagram className="w-5 h-5" />
            @raj_travels_goa
          </a>
        </div>
      </motion.div>
    </section>
  );
}
